query PartnershipAgreementOffline(
  $input: GetPartnershipAgreementOfflineInput!
) {
  brSalesPerson: getPartnershipAgreementOffline(input: $input) {
    id
    pendingAgreementDownloadUrl
    adminBrContact {
      id
      fullName
    }
  }
}
